<template>
  <section class="teacher">




        <teacher-overview class="first-screen teacher-components-item"></teacher-overview>
        <div class="teacher-components" >
<!--          <component class="teacher-components-item" v-for="item in componentList" :key="item.name" v-bind:is="item"></component>-->
<!--          <component class="teacher-components-item" v-for="com in comps" :key="com.name" :is="com.name" />-->
          <Serve class="teacher-components-item"></Serve>
          <News class="teacher-components-item"></News>
          <Schedule class="teacher-components-item"></Schedule>
          <TimeServe class="teacher-components-item"></TimeServe>
        </div>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex';
  import config from '@/configs';
  import Vue from 'vue';
  import TeacherOverview from './cards/teacher/teahcer-overview';
  import Serve from './Teacher/Serve';
  import News from './Teacher/News';
  import Schedule from './Teacher/Schedule';
  import TimeServe from './Teacher/TimeServe';

  export default {
    name: 'Teacher',
    components: {
      TeacherOverview,
      Serve,
      News,
      Schedule,
      TimeServe,

    },
    computed: {
      ...mapGetters(['token', 'userInfo', 'serveUrl', 'request', 'flowServeUrl', 'messageUrl', 'isias', 'schoolCode', 'userModules']),
      config() {
        return config;
      },
      comps() {
        return this.userModules
          .filter(item => item.show)
          .map(item => ({
            name: item.code
          }));
      }
    },
    data() {
      return {
        // 组件列表
        showOnlyDebugComponent: false,
        componentList: [] //调试支持，未弄明白不要擅自删除
        // comps: [],
        // cdn:
      };
    },
    created() {

      // let config = this.$store.state.ComponentConfig.componentConfig;
      // if (config.pages && config.pages['Teacher'] && config.pages['Teacher']['moudleList']) {
      //   let comList = config.pages['Teacher']['moudleList'];
      //   this.showOnlyDebugComponent = true;
      //   comList.forEach(item => {
      //     System.import(item.url)
      //       .then(com => {
      //         // debugger;
      //         const itemCom = com[item.name] || com['default'][item.name];
      //         const token = this.token;
      //         const temp = Vue.extend({
      //           render(h) {
      //             return h(
      //               itemCom,
      //               {
      //                 props: {
      //                   idToken: token,
      //                   userInfo: this.userInfo,
      //                   serveUrl: this.serveUrl,
      //                   baseUrl: this.serveUrl
      //                 }
      //               },
      //               ''
      //             );
      //           }
      //         });
      //         this.componentList.push(temp);
      //       })
      //       .catch(e => {
      //         // debugger;
      //       });
      //   });
      // } else if (config.pages && config.pages['Teacher']) {
      //   let comList = config.pages['Teacher'];
      //   comList.forEach(item => {
      //     System.import(item.url)
      //       .then(com => {
      //         // debugger;
      //         const itemCom = com[item.name] || com['default'][item.name];
      //         const token = this.token;
      //         const temp = Vue.extend({
      //           render(h) {
      //             return h(
      //               itemCom,
      //               {
      //                 props: {
      //                   idToken: token,
      //                   userInfo: this.userInfo,
      //                   serveUrl: this.serveUrl,
      //                   baseUrl: this.serveUrl,
      //                   request: this.request
      //                 }
      //               },
      //               ''
      //             );
      //           }
      //         });
      //         this.componentList.push(temp);
      //       })
      //       .catch(e => {
      //         // debugger;
      //       });
      //   });
      // }
    }
  };
</script>
<style lang="scss">
  @import '@/styles/variables.scss';
.teacher {

  width:100%;


}


  .teacher-components {
    margin-top:10px;
    & > div:first-child {
      padding-top: 40px;
      min-height: calc(100vh - 60px);
      // @include contentMedia;
    }
    width: 100%;
    .title {
      padding-top: 80px;
    }
  }
  .teacher-components-item {
    > div {

      max-width: 1920px;
    }
  }
  .first-screen {
    > div {
      width: 100%;
      margin-top: 20px;
    }
    @include portalMedia;
  }

</style>
